/**
 * @file 版本比较，类似 php version_compare
 * @author wangyongqing <wangyongqing01@baidu.com>
 */
import {toString} from './to';
/**
 * 版本比较，类似 php version_compare
 * @function version_compare
 * @param {string} version1 - 比较的版本1
 * @param {string} version2 - 比较的版本2
 * @return {number} 返回比较结果：0，-1，1
 */
export default (version1, version2) => {
    version1 = toString(version1, '');
    version2 = toString(version2, '');
    let a = version1.split('.');
    let b = version2.split('.');
    let i = 0;
    let len = Math.max(a.length, b.length);
    for (; i < len; i++) {
        if ((a[i] && !b[i] && parseInt(a[i], 10) > 0) || (parseInt(a[i], 10) > parseInt(b[i], 10))) {
            return 1;
        }
        else if ((b[i] && !a[i] && parseInt(b[i], 10) > 0) || (parseInt(a[i], 10) < parseInt(b[i], 10))) {
            return -1;
        }

    }
    return 0;
};
